import CIcon from "@coreui/icons-react";
import {freeSet} from "@coreui/icons";
import React from "react";

const ARIcon = (props) => <CIcon content={freeSet[props.name]} {...props} style={{fill: props.color || "currentColor"}}/>;

export default ARIcon;